import './Legend.scss';
import React from 'react';
import { Badge, Button, Col, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import { MdHelpOutline } from 'react-icons/md';
import { EventTypes } from '../../Constants/eventtype';

export interface LegendProps {}

const Legend: React.FC<LegendProps> = () => {
  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="bottom"
      overlay={
        <Popover className="legend-container border rounded-4">
          <Popover.Body>
            <p className="text-uppercase fw-bold small mb-3">Legend</p>
            <Row>
              <Col className="d-flex flex-column gap-2">
                <span className="d-flex align-items-center gap-2">
                  <div className="legend-indicator bg-dark rounded rounded-circle opacity-75" /> Registration closed
                </span>
                <span className="d-flex align-items-center gap-2">
                  <div className="legend-indicator bg-light rounded rounded-circle border border-black" /> Registration
                  open
                </span>
                <span className="d-flex align-items-center gap-2">
                  <div className="legend-indicator bg-light rounded rounded-circle" /> Registration coming soon
                </span>
              </Col>
              <Col className="d-flex flex-column gap-2">
                {Object.keys(EventTypes).map(type => (
                  <Badge
                    key={`legend-${type}`}
                    bg={`${EventTypes[type].color}-light`}
                    className={`text-start p-2 rounded text-${EventTypes[type].color}`}>
                    {EventTypes[type].name}
                  </Badge>
                ))}
              </Col>
            </Row>
          </Popover.Body>
        </Popover>
      }>
      <Button
        variant="outline"
        className="legend-btn p-0 d-flex align-items-center justify-content-center border-0 text-muted">
        <MdHelpOutline size={24} />
      </Button>
    </OverlayTrigger>
  );
};

export default Legend;
